import { render, staticRenderFns } from "./ReviewCardItem.vue?vue&type=template&id=55b1abe6&scoped=true&"
import script from "./ReviewCardItem.vue?vue&type=script&lang=js&"
export * from "./ReviewCardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b1abe6",
  null
  
)

export default component.exports